module.exports = __webpack_public_path__ + "static/some-afc18e78cad97090c5faa4125bf53c3a.png";